<style lang="less">
a.wzSubBtn,
a.wzSubBtn:visited {
  color:#999;
  border-color: #999;
}
a.wzSubBtn--closed,
a.wzSubBtn--closed:visited {
  color:#fb3d1b;
  border-color:#FB3D1B;
}
</style>
<template>
  <a :class="`wzSubBtn wzSubBtn--${hasSubscribed ? 'opened' : 'closed'}`"
    @click="goSub"
    href="javascript:;"
    ><span v-if="hasSubscribed">{{ textClose || '取消微信订阅' }}</span
    ><span v-else>{{ textOpen || '订阅微信通知' }}</span>
  </a>
</template>

<script>
import { apiRegister } from '../../utils/api'
import { getConst } from '../../utils/xp.v1'

// 1277	message	/message/sub/get/	我的微信服务号提醒
export const messageSubInfo = apiRegister('messageSubInfo', {
  protoId: 1277,
  path: '/message/sub/get/',
  checkQuery({ funcType }) {
    if (!(funcType > 0)) {
      return 1
    }
    return 0
  }
}).send

export default {
  name: 'wz-sub-btn',
  data() {
    return {
      sub: null
    }
  },
  props: ['funcType', 'textOpen', 'textClose'],
  computed: {
    // 判断是否已订阅
    hasSubscribed() {
      const { sub } = this
      return !!sub && sub.id > 0
    }
  },
  methods: {
    async fetch() {
      const { funcType } = this

      if (funcType) {
        await messageSubInfo({ funcType }).then(
          ({ sub }) => {
            this.sub = sub || null
          },
          () => void 0
        )
      }
    },

    goSub() {
      const { hasSubscribed, funcType } = this
      const domain = getConst('HOST_WEB')
      let url = `https://${domain}/message/sub/wx?` //redirectUrl
      if(hasSubscribed) {
        url += `funcType=${funcType}`
      } else {
        url += `open=${funcType}`
      }
      url += '&redirectUrl=' + encodeURIComponent(location.href)
      location.href = url
    }
  },
  created() {
    this.fetch()
  }
}
</script>
